export default "/images/49dfbe5289d549553c4929c5964bcd58.avif";